import React, { useEffect, useState } from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    IconButton,
    Button,
    Typography,
    Select,
    MenuItem,
    FormControl,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputLabel
} from '@mui/material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Visibility as VisibilityIcon,
    Close as CloseIcon,
    AccountBalance as AccountBalanceIcon
} from '@mui/icons-material';
import AddressManagement from './address.js';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector
} from '@mui/x-data-grid-pro';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import axios from '../../../axios-order';
import BusinessIcon from '@mui/icons-material/Business';
import {
    Container,
    Grid
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import SelectInput from "../../../components/ui/basicSelectInput";
import InputField from "../../../components/ui/inputField";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { LoadingButton } from '@mui/lab';

// Allow letters, numbers, spaces, and common address punctuation only
ValidatorForm.addValidationRule('validAddressChars', (value) => {
    if (!value) return true;
    const allowedPattern = /^[A-Za-z0-9\s,#./()\-]+$/;
    return allowedPattern.test(value);
});

// Block common SQL injection / script keywords and symbols
ValidatorForm.addValidationRule('noSqlInjection', (value) => {
    if (!value) return true;
    const sqlPattern = /(\bselect\b|\binsert\b|\bupdate\b|\bdelete\b|\bdrop\b|\bunion\b|\balter\b|\bcreate\b|\btruncate\b|\bexec\b|\bexecute\b|--|\/\*|\*\/|;|'|"|xp_)/i;
    return !sqlPattern.test(value);
});

const CompanyTable = () => {
    // Sample data
    const [supplierData, setSupplierData] = useState([])
    // Form state
    const [bankFormData, setBankFormData] = useState({
        bankName: '',
        accountNumber: '',
        ifscCode: '',
        accountHolderName: ''
    });

    const [formData, setFormData] = useState({
        gstin: '',
        tradeName: '',
        entityType: '',
        legalName: '',
        supplierAddress1: '',
        supplierAddress2: '',
        supplierLocation: '',
        pinCode: '',
        emailId: '',
        phone: '',
        state: '',
        common_supplier_id: ''
    });

    const [addressForm, setAddressForm] = useState({
        legalName: '',
        pinCode: '',
        location: '',
        address1: '',
        address2: '',
        state: '',
    })
    const [addressDialogOpen, setAddressDialogOpen] = useState(false);
    const [bankDialogOpen, setBankDialogOpen] = useState(false);
    const [supplierFormDialogOpen, setSupplierFormDialogOpen] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState({});
    const [supplierDailogKey, setSupplierDailogKey] = useState('')
    const [gstArray, setGstArray] = useState([])
    const [legalNameArray, setLegalNameArray] = useState([])
    const [stateArray, setStateArray] = useState([])
    const [pincodeError, setPincodeError] = useState('');
    const [pincodeLoading, setPincodeLoading] = useState(false);
    const [pincodeValid, setPincodeValid] = useState(false);
    const [logoFile, setLogoFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [error, setError] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("");
    const [message, setMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState("");
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false)
    const [form16DataLoading, setForm16DataLoading] = useState(false)
    const [supplierAddresses, setSupplierAddresses] = useState([])
    const [selectedSubAddress, setSelectedSubAddress] = useState({})
    const [selectedBank, setSelectedBank] = useState({})
    const [bankDetails, setBankDetails] = useState([])


    const handleSnackbarOpen = (message, severity) => {
        setSnackbarSeverity(severity);
        setResponseMessage(message);
        setSnackbarOpen(true);


        // setSnackbarOpen(false);
    };


    // Function to close Snackbar
    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity(snackbarSeverity);
        setResponseMessage("");

    };


    const columns = [
        {
            field: 'supplier_gstin',
            headerName: 'GSTIN',
            flex: 1, // Allows it to take available space
            minWidth: 150, // Minimum width
            align: 'left',
            filterable: true,
        },
        {
            field: 'supplier_legal_name',
            headerName: 'Legal Name',
            flex: 1, // Makes it flexible
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'supplier_pincode',
            headerName: 'Pincode',
            flex: 0.7, // Adjust the flex to be a smaller width
            minWidth: 120, // Minimum width to prevent squishing
            pinned: 'left',
            align: 'left',
            filterable: true,
        },
        {
            field: 'supplier_email',
            headerName: 'Email',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'supplier_phone',
            headerName: 'Phone',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'actions',
            headerName: 'Action',
            flex: 1, // Makes it flexible
            minWidth: 200, // Minimum width to prevent squishing
            align: 'left',
            renderCell: (params) => {
                const row = params.row;

                return (
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                        <IconButton
                            size="medium"
                            onClick={() => handleOpenSupplierFormDialog("view", row.common_supplier_id)}
                            title="View Company"
                        >
                            <VisibilityIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>
                        <IconButton
                            size="medium"
                            onClick={() => handleOpenSupplierFormDialog("edit", row.common_supplier_id)}
                            title="Edit Company"
                        >
                            <EditIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>
                        <IconButton
                            size="medium"
                            onClick={() => handleOpenAddressDialog(row)}
                            title="Add Address"
                        >
                            <AddLocationIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>
                        <IconButton
                            size="medium"
                            onClick={() => handleOpenBankDialog(row)}
                            title="Bank Details"
                            sx={{ color: 'primary.main' }}
                        >
                            <AccountBalanceIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>
                    </div>
                );
            },
            filterable: false,
        },
    ];


    useEffect(() => {
        getCompanyData()
        getGstinInfo()
        getLegalNameInfo()
    }, [])


    // useEffect(() => {
    //     if (formData.pinCode && formData.pinCode.length === 6 && supplierDailogKey === "add") {
    //         getAddressByPincode(formData.pinCode);
    //     }
    // }, [formData.pinCode]);


    // useEffect(() => {
    //     const hasData = selectedSubAddress && Object.keys(selectedSubAddress).length > 0;
    //     if (addressForm.pinCode && addressForm.pinCode.length === 6 && !hasData) {
    //         getAddressByPincodeForAddressDailog();
    //     }
    // }, [addressForm.pinCode]);


    const getCompanyData = () => {
        setForm16DataLoading(true)
        axios.get(`/einvoice/get_supplier_master_details/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const records = res?.data?.records
                    setSupplierData(records)
                }
            }).catch((err) => {

            }).finally(() => {
                setForm16DataLoading(false)
            })
    }

    const getGstinInfo = () => {
        axios.get(`/einvoice/get_gst_info/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const gstList = res?.data?.records || []
                    if (gstList && gstList.length == 1) {
                        setFormData(prev => ({
                            ...prev,
                            gstin: gstList[0].gstin
                        }));

                    }
                    setGstArray(gstList)
                }
            }).catch((err) => {

            })
    }

    const getLegalNameInfo = () => {
        axios.get(`/einvoice/get_legal_name_info/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const legalNameList = res?.data?.records || []
                    if (legalNameList && legalNameList.length == 1) {
                        setFormData(prev => ({
                            ...prev,
                            legalName: legalNameList[0].legalName
                        }));

                    }
                    setLegalNameArray(legalNameList)
                }
            }).catch((err) => {

            })
    }

    const getAddressByPincode = (pinCode) => {
        setPincodeLoading(true);
        setPincodeValid(false);
        axios.get(`/einvoice/get_address_info/${pinCode}`)
            .then((res) => {
                if (res?.data?.status) {
                    const { area, district, state, location, pinCode } = res?.data?.address_info

                    setFormData(prev => ({
                        ...prev,
                        supplierAddress1: area || '',
                        supplierAddress2: location || '',
                        supplierLocation: district || '',
                        state: state || '',
                    }));

                    const stateArray = [{
                        "pincode": pinCode,
                        "state": state
                    }]

                    setPincodeError('');
                    setStateArray(stateArray)
                    setPincodeValid(true);
                }
            }).catch((err) => {

            }).finally(() => {
                setPincodeLoading(false);
            })
    }

    const getAddressByPincodeForAddressDailog = (pincode) => {
        setPincodeLoading(true);
        setPincodeValid(false);
        axios.get(`/einvoice/get_address_info/${pincode}`)
            .then((res) => {
                if (res?.data?.status) {
                    const { area, district, state, location } = res?.data?.address_info

                    setAddressForm(prev => ({
                        ...prev,
                        address1: area || '',
                        address2: location || '',
                        location: district || '',
                        state: state || '',
                    }));

                    setPincodeError('');
                    setStateArray(res?.data?.state_data || [])
                    setPincodeValid(true);
                }
            }).catch((err) => {

            }).finally(() => {
                setPincodeLoading(false);
            })
    }

    const getSupplierInfo = (supplier_id) => {
        axios.get(`/einvoice/get_supplier_master_info/${supplier_id}`)
            .then((res) => {
                if (res?.data?.status) {
                    const data = res?.data?.record
                    setFormData({
                        gstin: data.supplier_gstin,
                        tradeName: data.supplier_trade_name,
                        entityType: '',
                        legalName: data.supplier_legal_name,
                        supplierAddress1: data.supplier_address_one,
                        supplierAddress2: data.supplier_address_two,
                        supplierLocation: data.supplier_location,
                        pinCode: data.supplier_pincode,
                        emailId: data.supplier_email,
                        phone: data.supplier_phone,
                        state: data.supplier_state,
                        companyLogo: data.supplier_company_logo,
                        common_supplier_id: data.common_supplier_id
                    });
                    const stateArray = [{
                        "pincode": data.supplier_pincode,
                        "state": data.supplier_state
                    }]
                    setStateArray(stateArray)
                    setPreviewUrl(data.supplier_company_logo);
                }
            }).catch((err) => {

            })
    }

    const getSupplierAddressDetails = (record) => {
        axios.get(`/einvoice/get_supplier_child_info/${record.id}`)
            .then((res) => {
                if (res?.data?.status) {
                    setSupplierAddresses(res?.data?.records || [])
                }
            }).catch((err) => {

            })
    }

    const getBankDetails = (record) => {
        axios.get(`/einvoice/get_supplier_bank_details/${record.id}`)
            .then((res) => {
                if (res?.data?.status) {
                    setBankDetails(res?.data?.records || [])
                }
            }).catch((err) => {

            })
    }

    const handleOpenSupplierFormDialog = (dailogKey, common_supplier_id = null) => {
        if (common_supplier_id) {
            getSupplierInfo(common_supplier_id)
        }
        setSupplierDailogKey(dailogKey)
        setSupplierFormDialogOpen(true);
    };

    const clearSupplierForm = () => {
        setFormData({
            gstin: '',
            tradeName: '',
            entityType: '',
            legalName: '',
            supplierAddress1: '',
            supplierAddress2: '',
            supplierLocation: '',
            pinCode: '',
            emailId: '',
            phone: '',
            state: '',
            companyLogo: null
        });
        setLogoFile(null)
        setPreviewUrl(null)
        setError('')
        setStateArray([])
        setPincodeError('')
        setPincodeValid(false)
        setPincodeLoading(false)

    }

    const clearAddressForm = () => {
        setAddressForm({
            gstin: localStorage.getItem('gst'),
            legalName: '',
            pinCode: '',
            location: '',
            address1: '',
            address2: '',
            state: '',
        });
        setStateArray([])
        setPincodeError('')
        setPincodeValid(false)
        setPincodeLoading(false)
        setSelectedSubAddress({})
    }

    const clearBankForm = () => {
        setBankFormData({
            bankName: '',
            accountNumber: '',
            ifscCode: '',
            accountHolderName: ''
        });
        setSubmitButtonLoading(false)
        setSelectedBank({})

    }

    const handleCloseSupplierFormDialog = () => {
        clearSupplierForm()
        setSubmitButtonLoading(false)
        setSupplierFormDialogOpen(false);
        setSelectedCompany({})
    };

    const handleOpenAddressDialog = (record) => {
        setSelectedCompany(record)
        getSupplierAddressDetails(record)
        setAddressDialogOpen(true);
    };


    const handleCloseAddressDialog = () => {
        clearAddressForm()
        setSubmitButtonLoading(false)
        setAddressDialogOpen(false);
        setSelectedCompany({})
    };


    const handleOpenBankDialog = (record) => {
        getBankDetails(record)
        setSelectedCompany(record)
        setBankDialogOpen(true);
    };


    const handleCloseBankDialog = () => {
        clearBankForm()
        setBankDialogOpen(false)
        setSelectedCompany({})
        setSelectedBank({})
    };

    const CustomToolbar = () => (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                height: '60px',
                flexWrap: 'wrap',
                gap: 1,
                padding: '3px 10px',
                backgroundColor: '#ffffff',
                borderRadius: '4px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            }}
        >
            <Box sx={{ display: 'flex', gap: 1 }}>
                <GridToolbarColumnsButton
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
                <GridToolbarFilterButton
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
                <GridToolbarDensitySelector
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
            </Box>

            <Box sx={{ display: 'flex', gap: 1, alignSelf: 'center' }}>
                <Button
                    variant="contained"
                    startIcon={<ControlPointIcon />}
                    onClick={() => handleOpenSupplierFormDialog("add")}
                    style={{ height: '40px', backgroundColor: '#00b0ff' }}
                >
                    Add Company
                </Button>
            </Box>
        </Box>
    );


    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        if (name === "gstin") {
            const selectedGst = gstArray.find(item => item.gstin === value);
            if (selectedGst) {
                const matchedLegal = legalNameArray.find(
                    item => item.business_entity_id === selectedGst.business_entity_id
                );
                if (matchedLegal) {
                    setFormData(prev => ({
                        ...prev,
                        gstin: value,
                        legalName: matchedLegal.legalName
                    }));
                }
            }
        }

        if (name === "pinCode") {
            if (value.length === 6) {
                setPincodeValid(true);
                getAddressByPincode(value);
            } else {
                setPincodeValid(false);
                setFormData(prev => ({
                    ...prev,
                    supplierAddress1: '',
                    supplierAddress2: '',
                    supplierLocation: '',
                    state: ''
                }));
            }
        }
    };


    // const handleChangeAddressInfo = (e) => {
    //     const { name, value } = e.target;
    //     setAddressForm({ ...addressForm, [name]: value });
    //     if (name === "pinCode") {
    //         if (value.length === 6) {
    //             setPincodeValid(true);
    //             getAddressByPincode(value);
    //         } else {
    //             setPincodeValid(false);
    //             setFormData(prev => ({
    //                 ...prev,
    //                 address1: '',
    //                 address2: '',
    //                 location: '',
    //                 state: ''
    //             }));
    //         }
    //     }
       
    // }

    const handleChangeAddressInfo = (e) => {
    const { name, value } = e.target;
    setAddressForm({ ...addressForm, [name]: value });
    if (name === "pinCode") {
        if (value.length === 6) {
           
            getAddressByPincodeForAddressDailog(value)
        } else {
            setPincodeValid(false);
            setFormData(prev => ({
                ...prev,
                address1: '',
                address2: '',
                location: '',
                state: ''
            }));
        }
    }
}

    const handleAddBankInputChange = (e) => {
        const { name, value } = e.target;
        setBankFormData({ ...bankFormData, [name]: value });
    }


    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file type
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        if (!allowedTypes.includes(file.type)) {
            alert('Error: Only JPG, JPEG, and PNG images are allowed!');
            e.target.value = ''; // Clear the input
            return;
        }

        // Validate file size (1MB = 1048576 bytes)
        const maxSize = 5 * 1024 * 1024; // 1MB in bytes
        if (file.size > maxSize) {
            alert('Error: File size must be less than 5MB!');
            e.target.value = ''; // Clear the input
            return;
        }

        // If validation passes, proceed with upload
        const preview = URL.createObjectURL(file);
        setPreviewUrl(preview);

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64Logo = reader.result;
            setLogoFile(base64Logo);
        };
        reader.readAsDataURL(file);
    };


    const handleRemove = () => {
        setLogoFile(null);
        setPreviewUrl(null);
        setError('');
    };


    const updateSupplierMaster = (payLoadData) => {
        axios.put('/einvoice/update_supplier_master', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success')
                    handleCloseSupplierFormDialog()
                } else {
                    handleSnackbarOpen(res?.data?.message, 'warning')
                }
            }).catch((err) => {

            }).finally(() => {
                setSubmitButtonLoading(false)
                getCompanyData()
            })
    }


    const createSupplierMaster = (payLoadData) => {
        axios.post('/einvoice/create_supplier_master', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success')
                    handleCloseSupplierFormDialog()
                } else {
                    handleSnackbarOpen(res?.data?.message, 'warning')
                }
            }).catch((err) => {

            }).finally(() => {
                setSubmitButtonLoading(false)
                getCompanyData()
            })
    }


    const handleSubmit = (event) => {

        event.preventDefault();

        setSubmitButtonLoading(true)
        const payLoadData = {
            ...formData,
            business_entity_id: localStorage.getItem('business_entity_id'),
            company_logo: logoFile,
            entity_gstin: localStorage.getItem('gst'),
            branch_name: localStorage.getItem('branch_name')
        }

        switch (supplierDailogKey) {
            case "edit":
                updateSupplierMaster(payLoadData)
                break;
            default:
                createSupplierMaster(payLoadData)
                break;
        }

    };

    const createSupplierSubAddress = (payLoadData) => {
        axios.post('/einvoice/create_supplier_child', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success')
                    clearAddressForm()
                    getSupplierAddressDetails(selectedCompany)
                }
            }).catch((err) => {

            }).finally(() => {
                setSubmitButtonLoading(false)
            })
    }

    const updateSupplierSubAddress = (payLoadData) => {
        axios.put('/einvoice/update_supplier_child', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success')
                    clearAddressForm()
                    getSupplierAddressDetails(selectedCompany)
                }
            }).catch((err) => {

            }).finally(() => {
                setSubmitButtonLoading(false)
            })
    }

    const handleSubmitAddressDailog = (event) => {
        event.preventDefault();
        setSubmitButtonLoading(true)
        const payLoadData = {
            ...addressForm,
            business_entity_id: localStorage.getItem('business_entity_id'),
            common_supplier_id: selectedCompany.common_supplier_id,
            common_supplier_child_id: selectedSubAddress.common_supplier_child_id
        }
        const hasData = selectedSubAddress && Object.keys(selectedSubAddress).length > 0;
        if (hasData) {
            updateSupplierSubAddress(payLoadData)
        } else {
            createSupplierSubAddress(payLoadData)
        }
    }

    const creatSupplierBank = (payLoadData) => {
        if (bankDetails && bankDetails.length >= 1) {
            handleSnackbarOpen("You can only add one bank account. Additional accounts cannot be added.", 'warning');
            clearBankForm()
            return;
        }
        setSubmitButtonLoading(true)
        axios.post('/einvoice/add_supplier_bank_info', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success')
                    clearBankForm()
                    getBankDetails(selectedCompany)
                }
            }).catch((err) => {

            }).finally(() => {
                setSubmitButtonLoading(false)
            })
    }

    const updateSupplierBank = (payLoadData) => {
        setSubmitButtonLoading(true)
        axios.put('/einvoice/update_supplier_bank_info', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success')
                    clearBankForm()
                    getBankDetails(selectedCompany)
                }
            }).catch((err) => {

            }).finally(() => {
                setSubmitButtonLoading(false)
            })
    }

    const handleSubmitBankData = (event) => {
        event.preventDefault();

        const payLoadData = {
            ...bankFormData,
            business_entity_id: localStorage.getItem('business_entity_id'),
            common_supplier_id: selectedCompany.common_supplier_id,
            common_supplier_child_id: selectedBank.common_supplier_child_id
        }

        const hasData = selectedBank && Object.keys(selectedBank).length > 0;
        if (hasData) {
            updateSupplierBank(payLoadData)
        } else {
            creatSupplierBank(payLoadData)
        }


    }

    const handleSubAddressEdit = (record) => {
        setAddressForm({
            legalName: record.legal_name,
            pinCode: record.pincode,
            location: record.location,
            address1: record.address_one,
            address2: record.address_two,
            state: record.state,
        })
        const stateArray = [{
            "pincode": record.pincode,
            "state": record.state
        }]
        setStateArray(stateArray)
        setSelectedSubAddress(record)
    }

    const handleBankEdit = (record) => {

        setBankFormData({
            ifscCode: record.ifsc_code,
            accountHolderName: record.account_holder_name,
            accountNumber: record.account_number,
            bankName: record.bank_name,
        })
        setSelectedBank(record)
    }


    const AddCompanyDialog = () => {
        const isViewMode = supplierDailogKey === 'view';
        const isEditMode = supplierDailogKey === "edit"
        return (
            <Paper sx={{ width: '100%', bgcolor: 'background.paper', borderRadius: 1, boxShadow: 1 }}>
                <Container maxWidth="lg" sx={{ py: 4 }}>
                    <ValidatorForm
                        useRef="form"
                        onSubmit={handleSubmit}
                        onError={(errors) => console.log(errors)}
                    >
                        {/* Basic Info */}
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Basic Information
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4} mt={1}>

                                    <SelectInput
                                        choice_id="gstin"
                                        requiredField="*"
                                        validator={["required"]}
                                        errorMsg={["This field is required"]}
                                        choice_name="gstin"
                                        SelectLabel="Supplier GSTIN"
                                        name="gstin"
                                        value={formData.gstin}
                                        textOnchangeFunction={handleChange}
                                        choices={gstArray}
                                        disabled={isViewMode || isEditMode}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>
                                        Trade Name
                                        <span style={{ color: "red" }}>*</span>:
                                    </label>
                                    <TextValidator
                                        fullWidth={true}
                                        size="small"
                                        variant="outlined"
                                        name="tradeName"
                                        value={formData.tradeName}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode || isEditMode }}
                                        validators={["required", "validAddressChars", "noSqlInjection"]}
                                        errorMessages={["This field is required", "Invalid special characters detected", "Possible SQL injection detected"]}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Company Info */}
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Company Information
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4} mt={1}>

                                    <SelectInput
                                        choice_id="legalName"
                                        requiredField="*"
                                        validator={["required"]}
                                        errorMsg={["This field is required"]}
                                        choice_name="legalName"
                                        SelectLabel="Legal Name"
                                        name="legalName"
                                        value={formData.legalName}
                                        textOnchangeFunction={handleChange}
                                        choices={legalNameArray}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>
                                        Phone Number
                                    </label>
                                    <TextValidator
                                        InputProps={{ readOnly: isViewMode }}
                                        fullWidth={true}
                                        size="small"
                                        variant="outlined"
                                        name="phone"
                                        value={formData.phone ?? ""}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 10, readOnly: isViewMode }}
                                        onKeyPress={(event) => {
                                            if (!/^[0-9]$/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        errorMessages={[
                                            "Must be a mobile number",
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>
                                        Email Id
                                    </label>
                                    <TextValidator
                                        fullWidth={true}
                                        size="small"
                                        variant="outlined"
                                        name="emailId"
                                        value={formData.emailId}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        validators={[
                                            "matchRegexp:^\\s*([a-zA-Z0-9._%+-]+)@[a-zA-Z0-9.-]+\\.(com|co\\.in|in|net|org|gamil\\.com|sh)\\s*$"
                                        ]}

                                        errorMessages={[
                                            "Email is not valid",
                                        ]}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Address Info */}
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Address Information
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <label>
                                        Pincode
                                        <span style={{ color: "red" }}>*</span>:
                                    </label>
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="pinCode"
                                        value={formData.pinCode}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 6, readOnly: isViewMode }}
                                        onKeyPress={(event) => {
                                            if (!/^[0-9]$/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        validators={["required", "matchRegexp:^[0-9]{6}$"]}
                                        errorMessages={["This field is required", "Must be a 6-digit pincode"]}
                                        error={!!pincodeError}
                                        helperText={pincodeError}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {pincodeLoading ? (
                                                        <CircularProgress size={20} />
                                                    ) : pincodeValid ? (
                                                        <CheckCircleIcon style={{ color: 'green' }} />
                                                    ) : null}
                                                </InputAdornment>
                                            )
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={4} >
                                    <label>
                                        Supplier Address
                                        <span style={{ color: "red" }}>*</span>:
                                    </label>
                                    <TextValidator
                                        fullWidth={true}
                                        size="small"
                                        variant="outlined"
                                        name="supplierAddress1"
                                        value={formData.supplierAddress1}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        validators={["required", "validAddressChars", "noSqlInjection"]}
                                        errorMessages={["This field is required", "Invalid special characters detected", "Possible SQL injection detected"]}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>
                                        Supplier Location
                                        <span style={{ color: "red" }}>*</span>:
                                    </label>

                                    <TextValidator
                                        fullWidth={true}
                                        size="small"
                                        variant="outlined"
                                        name="supplierLocation"
                                        value={formData.supplierLocation}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        validators={["required", "validAddressChars", "noSqlInjection"]}
                                        errorMessages={["This field is required", "Invalid special characters detected", "Possible SQL injection detected"]}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4}>

                                    <label>
                                        Supplier Address 2
                                    </label>

                                    <TextValidator
                                        fullWidth={true}
                                        size="small"
                                        variant="outlined"
                                        name="supplierAddress2"
                                        value={formData.supplierAddress2}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        validators={["validAddressChars", "noSqlInjection"]}
                                        errorMessages={["Invalid special characters detected", "Possible SQL injection detected"]}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <label>
                                        State <span style={{ color: 'red' }}>*</span>
                                    </label>

                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="state"
                                        value={formData.state}
                                        onChange={handleChange}
                                        validators={["required", "validAddressChars", "noSqlInjection"]}
                                        errorMessages={["This field is required", "Invalid special characters detected", "Possible SQL injection detected"]}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                    />
                                </Grid>

                            </Grid>
                        </Box>

                        {/* Logo Upload */}
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                                Company Logo
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Button
                                            variant="outlined"
                                            component="label"
                                            sx={{
                                                color: 'green',
                                                borderColor: 'green',
                                                '&:hover': {
                                                    borderColor: 'darkgreen',
                                                    backgroundColor: 'rgba(0,128,0,0.04)',
                                                },
                                                minWidth: 0,
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '4px',
                                                padding: 0,
                                            }}
                                            size="small"
                                            disabled={isViewMode}
                                        >
                                            <CloudUploadIcon />
                                            <input
                                                type="file"
                                                accept="image/jpeg, image/jpg, image/png"
                                                hidden
                                                onChange={handleFileUpload}
                                                key={previewUrl ? 'has-image' : 'no-image'}
                                            />
                                        </Button>

                                        <Button
                                            variant="outlined"
                                            onClick={handleRemove}
                                            sx={{
                                                color: 'red',
                                                borderColor: 'red',
                                                '&:hover': {
                                                    borderColor: 'darkred',
                                                    backgroundColor: 'rgba(255,0,0,0.04)',
                                                },
                                                minWidth: 0,
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '4px',
                                                padding: 0,
                                            }}
                                            size="small"
                                            disabled={isViewMode}
                                        >
                                            <DeleteOutlineIcon />
                                        </Button>

                                        {previewUrl && (
                                            <img
                                                src={previewUrl}
                                                alt="Logo Preview"
                                                style={{ width: 60, height: 60, borderRadius: 4, objectFit: 'cover', border: '1px solid #ccc' }}
                                            />
                                        )}
                                    </Box>

                                    {error && (
                                        <Typography variant="caption" sx={{ color: 'red', mt: 1, display: 'block' }}>
                                            {error}
                                        </Typography>
                                    )}

                                    <Typography variant="caption" sx={{ display: 'block', color: '#888', mt: 1 }}>
                                        Preferred Image Dimensions: 240×240 pixels @ 72 DPI
                                    </Typography>
                                    <Typography variant="caption" sx={{ display: 'block', color: '#888' }}>
                                        Maximum File Size: 5MB
                                    </Typography>
                                    <Typography variant="caption" sx={{ display: 'block', color: '#888' }}>
                                        Format - JPG, JPEG & PNG
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Submit Buttons */}
                        {!isViewMode && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                                {!isEditMode &&
                                    <Button variant="outlined" sx={{ mr: 2 }} onClick={clearSupplierForm}>
                                        Clear
                                    </Button>
                                }
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    loading={submitButtonLoading}
                                >
                                    Submit
                                </LoadingButton>
                            </Box>
                        )}
                    </ValidatorForm>
                </Container>
            </Paper>

        );
    };


    const AddressDialogContent = () => {
        const hasData = selectedSubAddress && Object.keys(selectedSubAddress).length > 0;
        const isEditMode = hasData;

        return (
            <Container maxWidth="lg" sx={{ mt: 1, mb: 2 }}>
                {/* Form Section */}
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 3,
                        backgroundColor: 'background.paper',
                    }}
                >
                    <Typography variant="h6" fontWeight={550} gutterBottom>
                        {isEditMode ? 'Edit Supplier Address' : 'Add Supplier Address'}
                    </Typography>

                    <ValidatorForm onSubmit={handleSubmitAddressDailog} onError={(errors) => console.log(errors)}>
                        <Grid container spacing={3}>
                            {/* Legal Name */}
                            <Grid item xs={12} sm={4} mt={1}>
                                <SelectInput
                                    choice_id="legalName"
                                    requiredField="*"
                                    validator={["required"]}
                                    errorMsg={["This field is required"]}
                                    choice_name="legalName"
                                    SelectLabel="Legal Name"
                                    name="legalName"
                                    value={selectedCompany.supplier_legal_name}
                                    // textOnchangeFunction={handleChange}
                                    choices={legalNameArray}
                                    disabled={true}
                                />
                            </Grid>

                            {/* Pincode */}
                            <Grid item xs={12} sm={4}>
                                <label>
                                    Pincode
                                    <span style={{ color: "red" }}>*</span>:
                                </label>
                                <TextValidator
                                    label="Pincode *"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="pinCode"
                                    value={addressForm.pinCode}
                                    onChange={handleChangeAddressInfo}
                                    inputProps={{ maxLength: 6, }}
                                    onKeyPress={(e) => {
                                        if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                                    }}
                                    validators={["required", "matchRegexp:^[0-9]{6}$"]}
                                    errorMessages={["This field is required", "Must be a 6-digit pincode"]}
                                    error={!!pincodeError}
                                    helperText={pincodeError}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {pincodeLoading ? (
                                                    <CircularProgress size={20} />
                                                ) : pincodeValid ? (
                                                    <CheckCircleIcon sx={{ color: 'green' }} />
                                                ) : null}
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>

                            {/* Location */}
                            <Grid item xs={12} sm={4}>
                                <label>
                                    Location
                                    <span style={{ color: "red" }}>*</span>:
                                </label>
                                <TextValidator
                                    label="Location *"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="location"
                                    value={addressForm.location}
                                    onChange={handleChangeAddressInfo}
                                    inputProps={{ maxLength: 100 }}
                                    validators={["required", "validAddressChars", "noSqlInjection"]}
                                    errorMessages={["This field is required", "Invalid special characters detected", "Possible SQL injection detected"]}
                                />
                            </Grid>

                            {/* Address Line 1 */}
                            <Grid item xs={12} sm={6}>
                                <label>
                                    Primary Address
                                    <span style={{ color: "red" }}>*</span>:
                                </label>
                                <TextValidator
                                    label="Address Line 1 *"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="address1"
                                    value={addressForm.address1}
                                    onChange={handleChangeAddressInfo}
                                    inputProps={{ maxLength: 100 }}
                                    validators={["required", "validAddressChars", "noSqlInjection"]}
                                    errorMessages={["This field is required", "Invalid special characters detected", "Possible SQL injection detected"]}
                                />
                            </Grid>

                            {/* Address Line 2 */}
                            <Grid item xs={12} sm={6}>
                                <label>
                                    Secondary Address
                                    <span style={{ color: "red" }}>*</span>:
                                </label>
                                <TextValidator
                                    label="Address Line 2 *"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="address2"
                                    value={addressForm.address2}
                                    onChange={handleChangeAddressInfo}
                                    inputProps={{ maxLength: 100 }}
                                    validators={["required", "validAddressChars", "noSqlInjection"]}
                                    errorMessages={["This field is required", "Invalid special characters detected", "Possible SQL injection detected"]}
                                />
                            </Grid>

                            {/* State */}
                            <Grid item xs={12} sm={4} mt={1}>
                                <label>
                                    State <span style={{ color: 'red' }}>*</span>
                                </label>
                                <TextValidator
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="state"
                                    value={addressForm.state}
                                    onChange={handleChangeAddressInfo}
                                    validators={["required", "validAddressChars", "noSqlInjection"]}
                                    errorMessages={["This field is required", "Invalid special characters detected", "Possible SQL injection detected"]}
                                    inputProps={{ maxLength: 100 }}
                                />
                            </Grid>
                        </Grid>

                        {/* Form Buttons */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    mr: 2,
                                    color: 'text.secondary',
                                    borderColor: 'text.secondary',
                                    '&:hover': {
                                        backgroundColor: 'action.hover',
                                        borderColor: 'text.primary',
                                    },
                                }}
                                onClick={clearAddressForm}
                            >
                                Clear
                            </Button>
                            <LoadingButton
                                variant="contained"
                                color="primary"
                                type="submit"
                                loading={submitButtonLoading}
                            >
                                Submit
                            </LoadingButton>
                        </Box>
                    </ValidatorForm>
                </Paper>

                {/* Submitted Entries */}
                <Paper
                    elevation={3}
                    sx={{
                        mt: 2,
                        p: 1,
                        borderRadius: 3,
                        backgroundColor: '#fafafa',
                        boxShadow: '0px 1px 10px rgba(0,0,0,0.05)',
                    }}
                >
                    <Typography variant="h6" fontWeight={550} gutterBottom style={{ marginLeft: 4 }}>
                        Sub Address
                    </Typography>

                    <TableContainer sx={{ boxShadow: 2, borderRadius: 2, overflow: 'hidden', bgcolor: 'background.paper' }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{
                                    bgcolor: 'primary.main',
                                    color: 'white',
                                    '& th': { fontWeight: 'bold', fontSize: '1rem' },
                                }}>
                                    <TableCell sx={{ color: '#000000' }}>Primary Address</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>Secondary Address</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>Location</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>State</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>Pincode</TableCell>
                                    <TableCell align="center" sx={{ color: '#000000' }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {supplierAddresses.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center" sx={{ padding: 2, color: 'red' }}>
                                            No Data Available
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    supplierAddresses.map((supplier) => (
                                        <TableRow
                                            key={supplier.id}
                                            hover
                                            sx={{
                                                '&:hover': { bgcolor: 'action.hover' },
                                                transition: 'all 0.2s ease',
                                            }}
                                        >
                                            <TableCell sx={{ padding: 2 }}>{supplier.address_one}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{supplier.address_two}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{supplier.location}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{supplier.state}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{supplier.pincode}</TableCell>
                                            <TableCell align="center" sx={{ padding: 2 }}>
                                                <IconButton
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: 'action.selected',
                                                        color: 'text.primary',
                                                        '&:hover': {
                                                            backgroundColor: 'primary.main',
                                                            color: 'white',
                                                        },
                                                    }}
                                                    onClick={() => handleSubAddressEdit(supplier)}
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Container>
        );
    };


    const BankDailogContent = () => {
        const hasData = selectedBank && Object.keys(selectedBank).length > 0;
        const isEditMode = hasData;

        return (
            <Container maxWidth="lg" sx={{ mt: 1, mb: 2 }}>
                {/* Form Section */}
                <Paper

                    sx={{
                        p: 2,
                        borderRadius: 3,
                        backgroundColor: 'background.paper',

                    }}
                >
                    <Typography variant="h6" fontWeight={550} gutterBottom>
                        {isEditMode ? 'Edit Bank' : 'Add Bank'}
                    </Typography>

                    <ValidatorForm onSubmit={handleSubmitBankData} onError={(errors) => console.log(errors)}>
                        <Grid container spacing={2}>
                            {/* IFSC Code */}
                            <Grid item xs={12} sm={6}>
                                <InputField
                                    inputType="text"
                                    textLabel="IFSC Code"
                                    name="ifscCode"
                                    requiredField="*"
                                    inputProps={{ maxLength: 11 }}
                                    validator={[
                                        "required",
                                        "matchRegexp:^[A-Z|a-z]{4}[0][a-zA-Z0-9]{6}$",
                                    ]}
                                    errorMsg={["This field is required", "IFSC code is not valid"]}
                                    value={bankFormData.ifscCode}
                                    textOnchangeFunction={handleAddBankInputChange}
                                />
                            </Grid>

                            {/* Account Number */}
                            <Grid item xs={12} sm={6}>
                                <InputField
                                    inputType="text"
                                    textLabel="Account Number"
                                    requiredField="*"
                                    inputProps={{ maxLength: 20 }}
                                    validator={["required", "matchRegexp:^[0-9]{9,20}$"]}
                                    errorMsg={[
                                        "This field is required",
                                        "The bank number should have 9-20 digits",
                                    ]}
                                    name="accountNumber"
                                    value={bankFormData.accountNumber}
                                    textOnchangeFunction={handleAddBankInputChange}
                                />
                            </Grid>

                            {/* Location */}
                            <Grid item xs={12} sm={6}>
                                <InputField
                                    inputType="text"
                                    textLabel="Bank Name"
                                    name="bankName"
                                    inputProps={{ maxLength: 100 }}
                                    requiredField="*"
                                    validator={["required"]}
                                    errorMsg={["This field is required"]}
                                    value={bankFormData.bankName}
                                    textOnchangeFunction={handleAddBankInputChange}
                                />
                            </Grid>

                            {/* Address Line 1 */}
                            <Grid item xs={12} sm={6}>
                                <InputField
                                    inputType="text"
                                    textLabel="Account Holder Name"
                                    name="accountHolderName"
                                    inputProps={{ maxLength: 100 }}
                                    requiredField="*"
                                    validator={["required"]}
                                    errorMsg={["This field is required"]}
                                    value={bankFormData.accountHolderName}
                                    textOnchangeFunction={handleAddBankInputChange}
                                />
                            </Grid>
                        </Grid>

                        {/* Form Buttons */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    mr: 2,
                                    color: 'text.secondary',
                                    borderColor: 'text.secondary',
                                    '&:hover': {
                                        backgroundColor: 'action.hover',
                                        borderColor: 'text.primary',
                                    },
                                }}
                                onClick={clearBankForm}
                            >
                                Clear
                            </Button>
                            <LoadingButton
                                variant="contained"
                                color="primary"
                                type="submit"
                                loading={submitButtonLoading}
                            >
                                Submit
                            </LoadingButton>
                        </Box>
                    </ValidatorForm>
                </Paper>

                {/* Submitted Entries */}
                <Paper
                    elevation={3}
                    sx={{
                        mt: 2,
                        p: 1,
                        borderRadius: 3,
                        backgroundColor: '#fafafa',
                        boxShadow: '0px 1px 10px rgba(0,0,0,0.05)',
                    }}
                >
                    <TableContainer sx={{ boxShadow: 2, borderRadius: 2, overflow: 'hidden', bgcolor: 'background.paper' }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{
                                    bgcolor: 'primary.main',
                                    color: 'white',
                                    '& th': { fontWeight: 'bold', fontSize: '1rem' },
                                }}>
                                    <TableCell sx={{ color: '#000000' }}>Account Holder Name</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>Account Number</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>IFSC Code</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>Bank Name</TableCell>
                                    <TableCell sx={{ color: '#000000' }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {bankDetails.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center" sx={{ padding: 2, color: 'red' }}>
                                            No Data Available
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    bankDetails.map((bank) => (
                                        <TableRow
                                            key={bank.id}
                                            hover
                                            sx={{
                                                '&:hover': { bgcolor: 'action.hover' },
                                                transition: 'all 0.2s ease',
                                            }}
                                        >
                                            <TableCell sx={{ padding: 2 }}>{bank.account_holder_name}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{bank.account_number}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{bank.ifsc_code}</TableCell>
                                            <TableCell sx={{ padding: 2 }}>{bank.bank_name}</TableCell>
                                            <TableCell align="center" sx={{ padding: 2 }}>
                                                <IconButton
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: 'action.selected',
                                                        color: 'text.primary',
                                                        '&:hover': {
                                                            backgroundColor: 'primary.main',
                                                            color: 'white',
                                                        },
                                                    }}
                                                    onClick={() => handleBankEdit(bank)}
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </Paper>
            </Container>
        );
    };


    return (
        <div>

            {/* Main Table View */}


            <Box sx={{ height: '65vh', width: '100%', marginTop: '0.8%' }}>
                <DataGridPro
                    rows={supplierData}
                    columns={columns}
                    loading={form16DataLoading}
                    // apiRef={gridApiRef}
                    localeText={{
                        toolbarDensity: 'Size',
                        toolbarDensityLabel: 'Size',
                        toolbarDensityCompact: 'Small',
                        toolbarDensityStandard: 'Medium',
                        toolbarDensityComfortable: 'Large',
                    }}
                    sx={{
                        maxHeight: '65vh',
                        '& .MuiDataGrid-columnHeaders': {
                            // backgroundColor: '#1976d2',
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            textAlign: 'right',
                            zIndex: 1000,
                        },
                        '& .MuiDataGrid-columnHeader': {
                            position: 'relative',
                            textAlign: 'right',
                            width: '100%',
                            fontWeight: 'bold',
                            backgroundColor: '#607d8b',
                        },

                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#fff',
                        },
                        "& .MuiDataGrid-sortIcon": {
                            opacity: 'inherit !important',
                        },

                        "& .MuiDataGrid-iconButtonContainer": {
                            visibility: 'visible',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            opacity: '1 !important',
                            visibility: 'visible !important',
                            display: 'flex !important',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            '& .MuiDataGrid-columnHeader': {
                                '& .MuiDataGrid-menuIconButton': {
                                    display: 'flex !important',
                                    visibility: 'visible !important',
                                    opacity: '1 !important',
                                },
                            },
                        },
                        '& .MuiDataGrid-columnHeaderIcon': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#f9f9f9',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '8px',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#f0f0f0',
                        },
                        '& .MuiCheckbox-root': {
                            color: '#1976d2',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#d3e3fc',
                            cursor: 'pointer'
                        },


                    }}
                    pagination
                    pageSize={5}
                    pageSizeOptions={[5, 10, 25, 50]}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />

            </Box>

            {/* Supplier Form Dialog */}
            <Dialog
                open={supplierFormDialogOpen}
                onClose={handleCloseSupplierFormDialog}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        boxShadow: 24,
                        px: 2,
                        py: 1,
                        marginLeft: 8,
                        bgcolor: 'background.default'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1,
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <BusinessIcon color="primary" />
                        <Typography variant="h6" fontWeight="bold">
                            {supplierDailogKey === 'add' && 'Add Company'}
                            {supplierDailogKey === 'edit' && 'Edit Company'}
                            {supplierDailogKey === 'view' && 'View Company'}
                        </Typography>
                    </Box>
                    <IconButton onClick={handleCloseSupplierFormDialog} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>


                <DialogContent dividers sx={{ px: 3, py: 2 }}>

                    {AddCompanyDialog()}

                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent: 'flex-end',
                        px: 3,
                        py: 2,
                        borderTop: 1,
                        borderColor: 'divider',
                        bgcolor: 'background.default',
                    }}
                >
                    <Button onClick={handleCloseSupplierFormDialog} variant="outlined">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Address Management Dialog */}
            <Dialog
                open={addressDialogOpen}
                onClose={handleCloseAddressDialog}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" fontWeight={550} gutterBottom style={{ marginLeft: 4 }}>Manage Addresses</Typography>
                    <IconButton onClick={handleCloseAddressDialog} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {AddressDialogContent()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddressDialog}>Close</Button>
                </DialogActions>
            </Dialog>

            {/* Bank Management Dialog */}
            <Dialog
                open={bankDialogOpen}
                onClose={handleCloseBankDialog}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" fontWeight={550} gutterBottom>
                        Bank Details
                    </Typography>
                    <IconButton onClick={handleCloseBankDialog} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {BankDailogContent()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseBankDialog}>Close</Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={4500}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>
        </div>
    );
};

export default CompanyTable;